<div class="doc-drop">
  <label
    class="doc-drop__zone"
    [class.doc-drop__zone--active]="isDragging()"
    [class.doc-drop__zone--disabled]="disabled()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
  >
    <input
      type="file"
      class="doc-drop__input"
      multiple
      [accept]="accept"
      [disabled]="disabled()"
      (change)="onFileInput($event)"
      [attr.aria-label]="'Add ' + docType().label"
      [attr.data-testid]="'doc-drop-' + docType().value"
    />
    <span class="doc-drop__icon"><app-icon name="upload" [size]="20" /></span>
    <span class="doc-drop__title">{{ docType().label }}</span>
    @if (docType().hint) {
      <span class="doc-drop__hint">{{ docType().hint }}</span>
    }
    <span class="doc-drop__cta">
      Drop files here, or <span class="doc-drop__browse">browse</span>
    </span>
    <span class="doc-drop__limits">{{ limitsText }}</span>
  </label>

  @if (rejectionError()) {
    <p
      class="doc-drop__error"
      role="alert"
      [attr.data-testid]="'doc-drop-error-' + docType().value"
    >
      {{ rejectionError() }}
    </p>
  }

  @if (uploads().length > 0) {
    <ul class="doc-drop__list" [attr.aria-label]="docType().label + ' files'">
      @for (u of uploads(); track u.id) {
        <!-- Keyed by file name so a test can assert the verdict for a SPECIFIC
             upload; the id is a server short_id the spec never sees. -->
        <li [attr.data-testid]="'doc-file-' + u.fileName">
          <app-doc-verdict
            [fileName]="u.fileName"
            [status]="u.doc?.assess_status ?? 'PENDING'"
            [message]="u.doc?.assess_message ?? ''"
            [errorText]="errorTextFor(u)"
          >
            @if (u.state !== 'uploading') {
              <button
                doc-verdict-trailing
                type="button"
                class="doc-file__remove"
                [disabled]="isDeleting(u)"
                (click)="remove.emit(u.id)"
                [attr.aria-label]="'Remove ' + u.fileName"
                [matTooltip]="isDeleting(u) ? 'Removing…' : 'Remove document'"
              >
                <app-icon name="x" [size]="16" />
              </button>
            }
          </app-doc-verdict>
        </li>
      }
    </ul>
  }
</div>
